import { Component, ContentChild, Input } from '@angular/core';
import { Color } from '@lsq-frontend/common-ui';
import { Icons, LsqButtonComponent } from '@lsq-frontend/common-ui';

@Component({
    selector: 'no-data-box',
    template: `
        <div
            class="no-data-box"
            [ngClass]="{
                'light-gray-bg': lightGrayBg
            }"
        >
            <div class="no-data-box-text">
                <h3 class="no-data-box-title font-weight-bold">
                    {{ titleText }}
                </h3>
                <p *ngIf="!!description" class="no-data-box-description">
                    {{ description }}
                </p>
            </div>

            <div *ngIf="iconType === icons.PiggyBank" class="no-data-box-icon">
                <div class="icon-border-top"></div>
                <div class="icon-border-right"></div>
                <div class="icon-border-bottom"></div>
                <div class="icon-border-left"></div>
                <lsq-icon
                    [type]="icons.PiggyBank"
                    [color]="color.GrayLight"
                    [width]="58"
                    [height]="58"
                >
                </lsq-icon>
            </div>

            <div *ngIf="iconType === icons.NoDataCheckedRows" class="no-data-box-icon">
                <lsq-icon [type]="icons.NoDataCheckedRows" [color]="color.Gray"> </lsq-icon>
            </div>

            <div *ngIf="!!button" class="no-data-box-button">
                <ng-content></ng-content>
            </div>
        </div>
    `
})
export class NoDataBoxComponent {
    @Input() public titleText: string;
    @Input() public description?: string;
    @Input() public iconType: typeof Icons.NoDataCheckedRows | typeof Icons.PiggyBank;
    @Input() public lightGrayBg = false;
    @ContentChild(LsqButtonComponent, { static: true }) public button: LsqButtonComponent;

    public icons = Icons;
    public color = Color;
}
